import { getJapaneseHeroName } from '../../data/TranslateJapaneseName';

/** API の hero_name の代わりに表示する名前（辞書があれば日本語、なければ API 名） */
export function heroDisplayName(heroId: number, apiHeroName: string): string {
  const ja = getJapaneseHeroName(heroId);
  return ja || apiHeroName;
}
